module.exports = __webpack_public_path__ + "media/images/sk25-8d29dce555141169fd2a0502af982ab9.svg";